import { statusKeys } from '../../helpers/projReportHelper';
import { isAdmin } from '../../services/rolesSvc';

export const canSendForApprove = (status, userCtx) => isAdmin(userCtx) && [statusKeys.inProgress, statusKeys.onRevision].includes(status);

export const canSendForRevision = (status, userCtx) => isAdmin(userCtx) && status === statusKeys.onExpertApprove;

export const canEdit = (status, userCtx) => {
  return isAdmin(userCtx);
}

const rules = {
  Edit: {
    isStatusOk: (status) => true,
    isRoleOk: (status, userCtx) => canEdit(status, userCtx),
  },
  Revision: {
    isStatusOk: (status) => true,
    isRoleOk: (status, userCtx) => canSendForRevision(status, userCtx),
  },
  Approve: {
    isStatusOk: (status) => true,
    isRoleOk: (status, userCtx) => canSendForApprove(status, userCtx),
  },
};

export const getActionsModel = (status, userCtx) => {
  return Object.entries(rules).reduce(
      (acc, [key, rule]) => ({
        ...acc,
        [key]:
        rule.isStatusOk(status) &&
        rule.isRoleOk(status, userCtx) &&
        (!rule?.extra || rule?.extra(status, userCtx)),
      }),
      {}
  );
};
